import {ActionTree} from "vuex";
import {RootState} from "../types/RootState";
import {TagsState} from "../types/TagsState";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { repositories } from "@service/api/Repositories";
import { ObjectRepository } from "@api/repositories/ObjectRepository";

export const actions: ActionTree<TagsState, RootState> = {
    async loadUsersTags({ rootState, rootGetters, commit, dispatch }) {
        const profileParams = rootGetters['events/selectedEventViewParam']('profile', null);

        const settings = profileParams?.tags;
        const tagsSchemaId = settings?.collectionId;
        if (!tagsSchemaId) { return; }

        const where = {
            groupIds: {
                $containsAnyOrNullOrEmpty: rootState.session.profile?.groupIds || []
            }
        }

        const result = await dispatch("loadTags", { condition: where, schemaId: tagsSchemaId })

        commit("setUsersTags", Object.freeze(result ?? []));
    },
    async loadSessionTags({ rootGetters, dispatch, rootState, commit }, tagsIds: string[] | undefined) {
        const stageViewParams = rootGetters['events/selectedEventViewParam']('stage', null);
        const tagsSchemaId = stageViewParams?.sessionTagsSchemaId || "Tags";

        const where = {
            groupIds: {
                $containsAnyOrNullOrEmpty: rootState.session.profile?.groupIds || []
            },
            ...(tagsIds ? { id: {$in: tagsIds} } : null)
        }

        const result = await dispatch("loadTags", { condition: where, schemaId: tagsSchemaId })

        commit("setSessionsTags", Object.freeze(result || []));
    },

    async loadTags({ dispatch }, { condition, schemaId }: { condition: any; schemaId: string }) {
        try {
            const result = await (repositories.get(RepositoryFabric.OBJECT) as ObjectRepository).query(schemaId, {
                take: -1,
                order: [{ column: "orderIndex", direction: "asc" }],
                where: condition
            });

            return result;
        }
        catch (e) {
            dispatch('reportException', e, { root: true });
            return null;
        }
    }
};